import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import language from '../../variables/language';
import '../../css/modals.css';

const emptyValues = () => ({start:'', end:'', date:'', notes:''});

export default function LessonCreateModal({ isOpen, studentId, onClose, onCreated }) {
   const navigate = useNavigate();
   const [values, setValues] = useState(emptyValues());
   const [saving, setSaving] = useState(false);

   if(!isOpen) return '';

   const stopProp = e => e.stopPropagation();

   const handleFieldChange = (name, value) => {
      setValues(prev => ({...prev, [name]: value}));
   }

   const handleClose = () => {
      setValues(emptyValues());
      onClose();
   }

   const handleSubmit = (e) => {
      e.preventDefault();
      if(saving) return;
      setSaving(true);
      const payload = { student: String(studentId) };
      Object.keys(values).forEach(key => {
         if(values[key] !== '') {
            payload[key] = values[key];
         }
      });
      axios.post('/api/events', JSON.stringify(payload), {
         withCredentials: true,
         headers: { 'Content-Type': 'application/json' },
      }).then(() => {
         setValues(emptyValues());
         onCreated();
      }).catch(err => {
         if(err.response && err.response.status === 401){
            navigate('/login');
         }
         console.log(err);
      }).finally(() => {
         setSaving(false);
      });
   }

   const lang = language[language.lang];

   return (
      <div className="modal-update" onClick={handleClose} style={{ display: 'flex' }}>
         <div className="modal-window" onClick={stopProp}>
            <h3 className="modal-w-title">{lang.modals.events.createTitle}</h3>
            <form onSubmit={handleSubmit}>
               <div className='student-lesson-create-fields'>
                  <div className='flex-from-input-wraper student-lesson-create-field' data-label={lang.start}>
                     <input className='submit-field from-input txt-c' type='time'
                        value={values.start} onChange={(e) => handleFieldChange('start', e.target.value)} />
                  </div>
                  <div className='flex-from-input-wraper student-lesson-create-field' data-label={lang.end}>
                     <input className='submit-field from-input txt-c' type='time'
                        value={values.end} onChange={(e) => handleFieldChange('end', e.target.value)} />
                  </div>
                  <div className='flex-from-input-wraper student-lesson-create-field-full' data-label={lang.date}>
                     <input className='submit-field from-input txt-c' type='date'
                        value={values.date} onChange={(e) => handleFieldChange('date', e.target.value)} />
                  </div>
                  <div className='flex-from-input-wraper student-lesson-create-field-full' data-label={lang.notes}>
                     <input className='submit-field from-input txt-c' type='text'
                        placeholder={lang.notes}
                        value={values.notes} onChange={(e) => handleFieldChange('notes', e.target.value)} />
                  </div>
               </div>
               <button type='submit' className='form-button txt-c' disabled={saving} style={{marginTop:14}}>
                  {saving ? lang['Loading ...'] : lang.save}
               </button>
            </form>
         </div>
      </div>
   );
}
